module.exports = __webpack_public_path__ + "img/panelView_strong_Bg_89_3_1.4456e76b.png";